import { onPageReady } from './utils';

function initialise() {
    setTimeout(() => {
        const marketingForms = document.querySelectorAll('.marketingForm');
        if (marketingForms.length) {
            const marketingForm = marketingForms[0];
            marketingForm.addEventListener('submit', () => {
                const dynamicsFormContainer = document.getElementById('dynamicsMarketingFormContainer');
                if (dynamicsFormContainer) {
                    setTimeout(() => {
                        dynamicsFormContainer.scrollIntoView();
                    }, 2000);
                }
            });
        }
    }, 6000);
}

onPageReady(initialise);
